import { storeDeliveryPossibleAreaMutationType, } from './types';
const mutations = {
    [storeDeliveryPossibleAreaMutationType.SET_IS_DIALOG_OPEN](state, isOpen) {
        state.isDialogOpen = isOpen;
    },
    // 가이아 데이터
    [storeDeliveryPossibleAreaMutationType.GET_SI_DO_LIST](state, list) {
        state.siDoList.constantGroups = list;
    },
    [storeDeliveryPossibleAreaMutationType.GET_SI_GUN_GU_LIST](state, list) {
        state.siGunGuList.constantGroups = list;
    },
    [storeDeliveryPossibleAreaMutationType.GET_EUP_MYEON_DONG_LIST](state, list) {
        state.eupMyeonDongList.constantGroups = list;
    },
    // 시도 시군구 선택
    [storeDeliveryPossibleAreaMutationType.SET_SI_DO](state, item) {
        state.selectedSiDo = item;
    },
    [storeDeliveryPossibleAreaMutationType.SET_SI_GUN_GU](state, item) {
        state.selectedSiGunGu = item;
    },
    // 가이아 데이터 리셋
    [storeDeliveryPossibleAreaMutationType.RESET_SI_DO_LIST](state) {
        state.siDoList = {
            constantGroups: [],
        };
        state.siDoList = {
            constantGroups: [],
        };
    },
    [storeDeliveryPossibleAreaMutationType.RESET_SI_GUN_GU_LIST](state) {
        state.siGunGuList = {
            constantGroups: [],
        };
        state.selectedSiGunGu = {
            constantGroupId: '',
            name: '',
        };
    },
    [storeDeliveryPossibleAreaMutationType.RESET_EUP_MYEON_DONG_LIST](state) {
        state.eupMyeonDongList = {
            constantGroups: [],
        };
    },
    // 상점별 zoo 데이터
    [storeDeliveryPossibleAreaMutationType.GET_STORE_DELIVERY_POSSIBLE_AREA_LIST](state, list) {
        state.storeDeliveryPossibleAreaList = list;
    },
    [storeDeliveryPossibleAreaMutationType.RESET_STORE_DELIVERY_POSSIBLE_AREA_LIST](state) {
        state.storeDeliveryPossibleAreaList = [];
    },
    // 등록/제외
    [storeDeliveryPossibleAreaMutationType.SET_DELIVERY_POSSIBLE_AREA_REGISTER](state, list) {
        state.register = list;
    },
    [storeDeliveryPossibleAreaMutationType.SET_DELIVERY_POSSIBLE_AREA_UNREGISTER](state, list) {
        state.unregister = list;
    },
    [storeDeliveryPossibleAreaMutationType.RESET_DIALOG](state) {
        // 가이아 데이터
        state.siDoList = {
            constantGroups: [],
        };
        state.siGunGuList = {
            constantGroups: [],
        };
        state.eupMyeonDongList = {
            constantGroups: [],
        };
        // 상점별 zoo 데이터
        state.storeDeliveryPossibleAreaList = [];
        // 선택 값
        state.selectedSiDo = {
            constantGroupId: '',
            name: '',
        };
        state.selectedSiGunGu = {
            constantGroupId: '',
            name: '',
        };
        state.register = [];
        state.unregister = [];
    },
};
export default mutations;
